// FullStory helper functions

export function fullStoryIdentify(id: string, data: Record<string, unknown>) {
    window.FS?.identify(id, data);
}

export function fullStoryAnonymize() {
    window.FS?.anonymize();
}
